import { Component, OnInit } from '@angular/core';

import { DialogTranslations } from '../../config';
import { DialogResult } from '../../models/dialog.result';
import { DialogBehaviorService } from '../../services/dialog-behavior.service';
import { DialogDataService } from '../../services/dialog-data.service';

@Component({
  selector: 'mw-dialog-additional-button',
  template: ` <button
    mat-stroked-button
    [disabled]="disabled || inProgress"
    (click)="onClick()"
    color="primary"
    class="m-0"
  >
    <div class="!flex items-center justify-center gap-2">
      <mat-spinner
        *ngIf="inProgress"
        color="accent"
        diameter="18"
        strokeWidth="3"
      ></mat-spinner>
      {{ translations.additionalButton | translate }}
    </div>
  </button>`,
})
export class AdditionalButtonComponent implements OnInit {
  disabled = false;
  inProgress = false;
  translations: DialogTranslations;
  constructor(
    private readonly dataService: DialogDataService,
    private behaviorService: DialogBehaviorService
  ) {}

  ngOnInit(): void {
    this.translations = this.dataService.translations;
    this.dataService
      .getDisabledState('additionalButton')
      .subscribe((disabled) => (this.disabled = disabled));

    this.dataService
      .getInProgressState('additionalButton')
      .subscribe((inProgress) => (this.inProgress = inProgress));
  }

  onClick(): void {
    this.dataService
      .getPreActions('additionalButton')
      .forEach((action) => action());
    this.behaviorService.additionalButtonClick.next();
    if (this.dataService.autoClose) {
      this.behaviorService.closeDialog.next(DialogResult.AdditionalButton);
    }
  }
}
